import React, { Component, MouseEvent } from 'react';
import Option from './option';
import feather from '../../img/feather-sprite.svg';

interface SelectListProps<T extends number | string> {
    values?: Array<T>;
    label?: string;
    disabled?: boolean;
    options?: Array<Option<T>>;
    onChange?: (t: Array<T>) => void;
}

interface SelectListState<T extends number | string> {
    selected?: T;
}

class SelectList<T extends number | string> extends Component<SelectListProps<T>, SelectListState<T>> {

    constructor(props: SelectListProps<T>) {
        super(props);
        this.state = {};
    }

    private handleOnChange = (e: React.FormEvent<HTMLSelectElement>) => {
        const { selectedIndex } = e.currentTarget;
        if (selectedIndex) {
            this.setState({
                selected: this.props.options![selectedIndex - 1].value
            });
        } else {
            this.setState({
                selected: undefined
            });
        }
    }

    private handleOnAddClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if (this.state.selected) {
            if (this.props.onChange) {
                if (this.props.values) {
                    let found = false;
                    this.props.values.forEach((item) => {
                        if (item === this.state.selected) {
                            found = true;
                        }
                    });
                    if (!found) {
                        this.props.onChange([this.state.selected, ...this.props.values]);
                    }
                } else {
                    this.props.onChange([this.state.selected]);
                }
            }
            this.setState({
                selected: undefined
            });
        }
    };

    private handleOnRemoveClick = (t: T) => {
        const values: Array<T> = [];
        this.props.values?.forEach((value) => {
            if (value !== t) {
                values.push(value);
            }
        });
        if (this.props.onChange) {
            this.props.onChange(values);
        }
    }

    render() {
        const values = this.props.values || [];
        const label = this.props.label ? <label className="label">{this.props.label}</label> : <></>;
        const disabled = !!this.props.disabled;
        const options = this.props.options || [];
        const hasSelection = this.state.selected !== undefined;
        const selected: number | string = this.state.selected || -1;
        return (
            <div className="field select-list">
                {label}
                <div className="control">
                    <div className="select">
                        <select disabled={disabled} onChange={this.handleOnChange} value={selected}>
                            <option key={-1} value={-1}></option>
                            {
                                options.map((option) => {
                                    return <option value={option.value} key={option.value}>{option.label}</option>;
                                })
                            }
                        </select>
                    </div>
                    <button className="button" disabled={!hasSelection} onClick={this.handleOnAddClick}>
                        <svg width="16" height="16" className="button-icon">
                            <use href={feather + "#plus"} />
                        </svg>
                    </button>
                </div>
                {
                    values.map((value) => {
                        let label = '';
                        for (let i = 0; i < options.length; i++) {
                            if (value === options[i].value) {
                                label = options[i].label;
                                break;
                            }
                        }
                        if (label !== '') {
                            const v = value;
                            return (
                                <div className="select-list-item" key={value}>
                                    <div className="select-list-label">{label}</div>
                                    <button className="button" onClick={() => this.handleOnRemoveClick(v)}>
                                        <svg width="16" height="16" className="button-icon">
                                            <use href={feather + "#x"} />
                                        </svg>
                                    </button>
                                </div>
                            );
                        }
                        return <></>;
                    })
                }
            </div>
        );
    }
}

export default SelectList;
